export const themes = [
  'accordion',
  'alert',
  'avatar',
  'badge',
  'breadcrumb',
  'button',
  'checkbox',
  'close-button',
  'code',
  'container',
  'divider',
  'drawer',
  'editable',
  'form-control',
  'form-error',
  'form-label',
  'heading',
  'index',
  'input',
  'kbd',
  'link',
  'list',
  'menu',
  'modal',
  'number-input',
  'pin-input',
  'popover',
  'progress',
  'radio',
  'select',
  'skeleton',
  'skip-link',
  'slider',
  'spinner',
  'stat',
  'switch',
  'table',
  'tabs',
  'tag',
  'textarea',
  'tooltip',
]
